"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  makeButtonSchemaPropTypes: true
};
Object.defineProperty(exports, "makeButtonSchemaPropTypes", {
  enumerable: true,
  get: function get() {
    return _schema.makeButtonSchemaPropTypes;
  }
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes2 = require("@decisiv/prop-types");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _StyledButton = _interopRequireDefault(require("./StyledButton"));

var _schema = require("./schema");

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _colors = require("./colors");

Object.keys(_colors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _colors[key];
    }
  });
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconMarginProp = {
  left: 'margin-right',
  right: 'margin-left'
};
var buttonSizeToSize = {
  small: 'small',
  medium: 'medium',
  large: 'medium',
  extraLarge: 'medium'
};

var iconMargin = function iconMargin(props) {
  return !props.iconOnly && "".concat(iconMarginProp[props.position], ": ").concat((0, _rem.default)(5));
};

var IconContainer = _styledComponents.default.span.withConfig({
  displayName: "Button__IconContainer",
  componentId: "f9svfu-0"
})(["line-height:0;", ";"], iconMargin);

var Button = function Button(props, ref) {
  var disabled = props.disabled,
      icon = props.icon,
      iconPosition = props.iconPosition,
      intent = props.intent,
      kind = props.kind,
      loading = props.loading,
      propLoadingText = props.loadingText,
      minWidth = props.minWidth,
      onClick = props.onClick,
      size = props.size,
      text = props.text,
      variant = props.variant,
      rest = _objectWithoutProperties(props, ["disabled", "icon", "iconPosition", "intent", "kind", "loading", "loadingText", "minWidth", "onClick", "size", "text", "variant"]);

  var translate = (0, _useTranslations.default)();
  var loadingVariant = (0, _react.useMemo)(function () {
    if (variant === 'ghost') return 'normal';
    return 'inverted';
  }, [variant]);
  var ButtonIcon = (0, _react.useMemo)(function () {
    var Icon = icon;
    return Icon && _react.default.createElement(IconContainer, {
      position: iconPosition,
      iconOnly: !text
    }, _react.default.createElement(Icon, {
      size: buttonSizeToSize[size]
    }));
  }, [icon, iconPosition, size, text]);
  var ButtonContent = (0, _react.useMemo)(function () {
    if (loading) {
      var loadingText = text ? translate(propLoadingText, 'button.loading') : undefined;
      var showLoadingText = !!text || !!loadingText;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Loading.default, {
        variant: loadingVariant,
        size: "small",
        marginRight: showLoadingText ? 0.5 : 0
      }), _react.default.createElement(_react.default.Fragment, null, showLoadingText && loadingText));
    }

    return _react.default.createElement(_react.default.Fragment, null, !!icon && iconPosition !== 'right' && ButtonIcon, !!text && text, !!icon && iconPosition === 'right' && ButtonIcon);
  }, [ButtonIcon, icon, iconPosition, loading, loadingVariant, propLoadingText, text, translate]);
  return _react.default.createElement(_StyledButton.default, _extends({
    disabled: disabled || loading,
    intent: intent,
    kind: kind,
    minWidth: minWidth,
    onClick: disabled ? _noop.default : onClick,
    ref: ref,
    size: size,
    type: "button",
    variant: variant,
    loading: loading
  }, rest), ButtonContent);
};

var propTypes = {
  'aria-label': (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref) {
    var text = _ref.text;
    return (0, _isEmpty.default)(text);
  }),
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.elementType,
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  intent: _propTypes.default.oneOf(['success', 'danger']),
  kind: _propTypes.default.oneOf(['primary', 'secondary']),
  loading: _propTypes.default.bool,
  loadingText: _propTypes.default.string,
  minWidth: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'extraLarge']),
  text: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['normal', 'inverted', 'ghost'])
};
var defaultProps = {
  disabled: false,
  icon: undefined,
  iconPosition: 'left',
  intent: undefined,
  kind: undefined,
  loading: false,
  loadingText: null,
  minWidth: undefined,
  size: 'medium',
  text: undefined,
  variant: 'normal'
};
var ButtonWithRef = (0, _react.forwardRef)(Button); // @ts-ignore

ButtonWithRef.propTypes = propTypes; // @ts-ignore

ButtonWithRef.defaultProps = defaultProps;
ButtonWithRef.displayName = 'Button';
var _default = ButtonWithRef;
exports.default = _default;